import { Button, Flex, Typography } from '@iheartjane/reefer';
import type { QualifyingStatusEnum } from '@iheartjane/types';

import { useKioskSpacing } from '../../../hooks';

interface SpecialDetailFooterProps {
  onCartClick: () => void;
  onShopMoreClick: () => void;
  qualifyingStatus: QualifyingStatusEnum;
}

export const SpecialDetailFooter = ({
  onCartClick,
  onShopMoreClick,
  qualifyingStatus,
}: SpecialDetailFooterProps) => {
  const { isIpad } = useKioskSpacing();
  const isApplied = qualifyingStatus === 'applied';

  if (!isApplied) return <></>;

  return (
    <Flex gap={24}>
      <Button
        full
        label={
          <Typography variant={`${isIpad ? 'body' : 'section'}-bold`}>
            Shop more deals
          </Typography>
        }
        onClick={onShopMoreClick}
        variant="tertiary"
        size={isIpad ? 'small' : 'large'}
      />
      <Button
        full
        label={
          <Typography
            color="text-info"
            variant={`${isIpad ? 'body' : 'section'}-bold`}
          >
            View bag
          </Typography>
        }
        onClick={onCartClick}
        variant="primary"
        size={isIpad ? 'small' : 'large'}
      />
    </Flex>
  );
};
